module.exports = __webpack_public_path__ + "static/img/battle_report2.f2cc1ef4.png";